import { Box, SvgIcon, SxProps, Theme, Tooltip } from "@mui/material";

export interface AddendumSignedIconProps {
  sx?: SxProps<Theme>;
}

const AddendumSignedIcon = ({ sx }: AddendumSignedIconProps) => (
  <Tooltip title="Addendum signed" placement="top" arrow>
    <Box
      role="img"
      aria-label="Addendum signed"
      sx={[
        {
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          width: 14,
          height: 14,
          color: "#7C3AED",
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <SvgIcon
        viewBox="0 0 24 24"
        sx={{
          fontSize: 14,
          fill: "none",
          stroke: "currentColor",
          strokeWidth: 2,
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
      >
        <path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
        <path d="M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z" />
      </SvgIcon>
    </Box>
  </Tooltip>
);

export default AddendumSignedIcon;
